import { render, staticRenderFns } from "./sortChart.vue?vue&type=template&id=0bab3272&scoped=true"
import script from "./sortChart.vue?vue&type=script&lang=js"
export * from "./sortChart.vue?vue&type=script&lang=js"
import style0 from "./sortChart.vue?vue&type=style&index=0&id=0bab3272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab3272",
  null
  
)

export default component.exports